module.exports = __webpack_public_path__ + "img/planting_03.1284389.webp";